<!-- Do not change this file. -->
<template>
  <div>
    <CustomAlert
      v-if="isDebugMode && 0"
      title="Debug"
      type="warning"
      :borderWidth="2"
    >
      <pre class="text-start">codeObject: {{ codeObject }}</pre>
      <pre class="text-start">achievementObject: {{ achievementObject }}</pre>
      <pre class="text-start">isCodeEarned:{{ isCodeEarned }}</pre>
    </CustomAlert>

    <div v-if="!isCodeValid">
      <!-- Code Is Not Valid -->
      <DynamicAlert v-bind="content.rewardAlertNotExist" />
    </div>
    <div v-else-if="isCodeEarned && 0">
      <!-- Code Already Earned -->
      <DynamicAlert v-bind="content.rewardAlertNotExist" />
    </div>
    <div v-else>
      <!-- Code Is Valid and Not Yet Earned -->
      <CodeManager
        :code="code"
        :codeObject="codeObject"
        :achievementObject="achievementObject"
      />
    </div>
  </div>
</template>

<script>
import CustomAlert from "@/components/ui/CustomAlert.vue";
import DynamicAlert from "@/components/reward/DynamicAlert.vue";
import CodeManager from "@/components/reward/CodeManager.vue";

import content from "@/data/content";

import { mapGetters } from "vuex";

export default {
  name: "CodeValidator",
  components: {
    CustomAlert,
    DynamicAlert,
    CodeManager
  },
  data() {
    return {
      content,
      isChecked: false
    };
  },
  props: {
    code: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters(["getCodes", "isDebugMode"]),
    ...mapGetters("content", ["getAchievements"]),
    allCodes() {
      return this.getAchievements.flatMap((achievement) => achievement.codes);
    },
    isCodeValid() {
      return this.allCodes.includes(this.code);
    },
    codeObject() {
      return this.getCodes.find((code) => code.code === this.code);
    },
    achievementObject() {
      return this.getAchievements.find((achievement) =>
        achievement.codes.includes(this.code)
      );
    },
    isCodeEarned() {
      if (!this.codeObject || !this.achievementObject) {
        return false;
      }
      if (this.codeObject.score >= this.achievementObject.targetScore) {
        return true;
      }

      return false;
    }
  }
};
</script>
